const LANGUAGE = {
  EN: 'en',
  FR: 'fr',
};

const URL_PREFIX = {
  EN: 'data-analytics-services',
  FR: 'services-analyse-donnees',
};

export { LANGUAGE, URL_PREFIX };
